import { makeAutoObservable } from "mobx";

export interface UserObservableRequestApi {
  name: string;
  password: string;
  mail: string;
}

export class EmptyRegistrationUserObservableRequestImpl
  implements UserObservableRequestApi
{
  name: string;
  password: string;
  mail: string;

  constructor() {
    this.name = "";
    this.password = "";
    this.mail = "";
    makeAutoObservable(this);
  }

  public onChangeName = (name: string) => {
    this.name = name;
  };

  public onChangeMail = (mail: string) => {
    this.mail = mail;
  };

  public onChangePassword = (password: string) => {
    this.password = password;
  };
}

export class EmptyLoginUserObservableRequestImpl
  implements UserObservableRequestApi
{
  name: string;
  password: string;
  mail: string;

  constructor() {
    this.name = "";
    this.password = "";
    this.mail = "";
    makeAutoObservable(this);
  }

  public onChangeMail = (mail: string) => {
    this.mail = mail;
  };

  public onChangePassword = (password: string) => {
    this.password = password;
  };
}
